var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-output',{attrs:{"errors":_vm.errors}},[_c('a-textarea',{ref:"focusOnMount",staticClass:"form-textarea",style:({ height: _vm.height }),attrs:{"disabled":!_vm.readOnly && _vm.disabled,"readOnly":_vm.readOnly},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }